import { render, staticRenderFns } from "./SelectCulturesComponent.vue?vue&type=template&id=c381d340"
import script from "./SelectCulturesComponent.vue?vue&type=script&lang=js"
export * from "./SelectCulturesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports